import { render, staticRenderFns } from "./VerificarAssinatura.vue?vue&type=template&id=30254db8&"
import script from "./VerificarAssinatura.vue?vue&type=script&lang=js&"
export * from "./VerificarAssinatura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports